/* MEE BARSA — Cart quantity steppers.
   +/- adjust the line quantity and submit the native cart form (applies the
   update, no AJAX). Drawer + reveal come from component-main-product.js.

   QUANTITY CEILING — added 2026-08-02 after regression testing.
   Every piece on this store sells with inventory tracking OFF, so Shopify will
   never refuse a quantity. A direct POST to /cart/add.js with quantity 99999
   was accepted and produced a cart line of 100,003. The input carried min="0"
   and no max, so the same was reachable by typing into the cart page.
   For a made-to-order brand currently taking cash on delivery, a six-figure
   COD order is not theoretical — it is a free way to waste Anjali's week.
   MB_MAX = 10 is Adarsh's call: generous for handmade jewellery, and anything
   above it should be a conversation rather than a checkout. Enforced in three
   places, because any one of them alone can be bypassed:
     1. the `max` attribute (browser UI + native validation)
     2. the + stepper (refuses to climb past it)
     3. a clamp on input/change (catches typing and paste) */
(function () {
  var MB_MAX = 10;
  var MB_MIN = 0; // 0 is allowed — it is how Shopify removes a line

  function clamp(input) {
    var v = parseInt(input.value, 10);
    if (isNaN(v)) { v = 1; }
    if (v < MB_MIN) { v = MB_MIN; }
    if (v > MB_MAX) { v = MB_MAX; }
    if (String(v) !== input.value) { input.value = v; }
    return v;
  }

  function initCart(root) {
    root = root || document;
    var scope = root.querySelector ? (root.querySelector('.mbpd') || root) : document;
    scope.querySelectorAll('.qty').forEach(function (q) {
      var input = q.querySelector('.qty-val');
      if (!input) return;
      if (input.__mbQtyBound) return;
      input.__mbQtyBound = true;

      input.setAttribute('max', String(MB_MAX));
      input.setAttribute('inputmode', 'numeric');

      var form = input.form;
      var minus = q.querySelector('.qty-minus');
      var plus = q.querySelector('.qty-plus');

      if (minus) minus.addEventListener('click', function () {
        var v = clamp(input);
        if (v > 1) { input.value = v - 1; if (form) form.submit(); }
      });

      // 2026-08-05 — the ceiling used to be announced only AFTER a click that
      // did nothing, which is the wrong order: the control looked live, was
      // pressed, and stayed silent. Reflect the state on load and after every
      // edit instead, so a line already at 10 arrives explained.
      function syncMax() {
        var atMax = clamp(input) >= MB_MAX;
        q.classList.toggle('is-max', atMax);
        if (!plus) return;
        if (atMax) {
          plus.setAttribute('aria-disabled', 'true');
          plus.setAttribute('title', 'For more than ' + MB_MAX + ', please write to us');
        } else {
          plus.removeAttribute('aria-disabled');
          plus.removeAttribute('title');
        }
      }

      if (plus) plus.addEventListener('click', function () {
        var v = clamp(input);
        if (v >= MB_MAX) { syncMax(); return; }
        input.value = v + 1;
        syncMax();
        if (form) form.submit();
      });

      // Typing and pasting both land here.
      input.addEventListener('input', function () { clamp(input); syncMax(); });
      input.addEventListener('change', function () { clamp(input); syncMax(); });
      syncMax();
      if (form) form.addEventListener('submit', function () { clamp(input); });
    });
  }

  if (document.readyState !== 'loading') { initCart(); }
  else { document.addEventListener('DOMContentLoaded', function () { initCart(); }); }
  document.addEventListener('shopify:section:load', function (e) { initCart(e.target); });
})();
